import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "./Icon.js";
export default function EmptyState({ iconName, title, body }) {
    return (_jsxs("div", { className: "empty", children: [_jsx("span", { className: "empty__ic", children: _jsx(Icon, { name: iconName, size: 26 }) }), _jsx("h4", { children: title }), _jsx("p", { children: body })] }));
}
//# sourceMappingURL=EmptyState.js.map